import * as React from 'react'

import { BaseIcon/*, Props*/ } from './BaseIcon'

export class Add extends BaseIcon {
  /*constructor (props: Props) {
    super(props)
  }*/

  public render () {
    const className = this.props.className ? `${this.defaults.className} ${this.getSize()} ${this.props.className}`
      : `${this.defaults.className} ${this.getSize()}`

    //const viewBox = this.props.viewBox ? this.props.viewBox : this.defaults.viewBox

    // tslint:disable    
    return (
      <svg className={className} viewBox="0 -960 960 960" ><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/></svg>
    )
 }
}
export default Add
